import styled from "styled-components";

export const ResourceCalendarBaseWrapper = styled.div<{ $theme?: string }>`
  width: 100%;
`;

export const ResourceCalendarHeaderWrapper = styled.div<{ $theme?: string }>`
  color: var(--primary-primary, #106ebe);
  text-align: left;
  font: var(--textstyleoutlook-h1, 600 24px/32px "Segoe UI", sans-serif);
  position: relative;
  .resourceCalendarHeader {
  max-width: 200px; /* Set a maximum width for the container */
  overflow: hidden;
}
.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block; /* Ensure the span is a block element */
}

`;

export const RrfReservationContentWrapper = styled.div<{ $theme?: string }>`
  width: auto;
  box-sizing: border-box;
  overflow: hidden;
  float: left;
  border-top: 1px solid #d2d2d2;
  min-width: 100%;
  font-size: 9pt;
  height: calc(100vh - 300px);
  overflow-y: auto;
  // margin: 15px;
`;

export const RrfReservationSelectedDateWrapper = styled.div<{
  $theme?: string;
}>`
  width: 100%;
  box-sizing: border-box;
  float: left;
  text-align: left;
  height: 30px;
  line-height: 25px;
  font-size: 9pt;
  font-weight: bold;
`;

export const RrfReservationListWrapper = styled.div<{ $theme?: string }>`
  overflow: hidden;
  width: auto;
  box-sizing: border-box;
  float: left;
`;

export const RrfReservationTblWrapper = styled.table`
  width: 100%;
  box-sizing: border-box;
  border-spacing: 0 8px;
  
.rc-attendee-meeting-info-status {
    width: 6px;
    height: 35px;
    display: table-cell;
}

.status-free {
    background: #69bf7f;
}

.status-tentative {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAOCAYAAADnqNYmAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB0SURBVHgBrc6xDUBQFIXh865Ko1CKSqlUSAwgsYAtDGEIW1jACCJRahUaHaJ5JJInt3tu7ZRfc361Hpfp+hnDtKIqE/ieC5KwnRokoWlHqGnZjQ1pHIAkFFkEksBzTJjXNvAxSeBjxZ02cAlJ+Cte38+n9QU9qWxenDVdnwAAAABJRU5ErkJggg==');
    background-repeat: repeat-y;
}

.status-busy {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAB5CAYAAAAwCKHzAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAACxMAAAsTAQCanBgAAABLSURBVFhH7cyxDYBAEMCwg5JB2YWpeUViAuiQ06Tzdlz3OR/an78OACgAoACAAgAKACgAoACAAgAKACgAoACAAgAKACgAoAA/AGYWHxYC6iWiSYwAAAAASUVORK5CYII=');
    background-repeat: repeat-y;
}

.status-outOfOffice {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAOCAYAAADnqNYmAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAhSURBVHgB5cgxEQAACAJAtH8p+9BBdo4G/PjD48MsguYUKNgDtLVKb6oAAAAASUVORK5CYII=');
    background-repeat: repeat-y;

}

.status-workingElsewhere {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAOCAYAAADnqNYmAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAxSURBVHgB3YyxDQAwCMOaftGbeyEXsDKygWBCiAvwkgyWwaJ2Gvd9ylMXo9mtAOuaDo7WNYLmd3yZAAAAAElFTkSuQmCC');
    background-repeat: repeat-y;
}

;

.status-noData {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAOCAYAAADnqNYmAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABkSURBVHgBrc6rDoAwEETR2U0AS0JAIAgOxf9/CA5FQDQ8RHE00JSsK6sZecxcMvYKu1lgjxVt1yNJM7CG2zmwhmkcQPN2hhjyogJrKOsGrEHGGuSYNcgxSWcMUsIa/or3/vm0vkKfbf5ipEn2AAAAAElFTkSuQmCC');
    background-repeat: repeat-y;
}

.status-own {
    background: #937bd1;
}

  td {
    vertical-align: top;
    white-space: nowrap;
    text-align: left;
    padding-bottom: 7px;

    &:first-child {
      padding-right: 5px;
    }

    &:last-child {
      white-space: normal;
      padding-left: 5px;
    }
  }
`;


export const RrfReservationContentChildWrapper = styled.div<{ $theme?: string }>`
    width: 100%;
    // box-sizing: border-box;
    float: left;
    // max-height:  450px;
    // overflow-y: auto !important;
    margin-top : 5px;
`;